import { render, staticRenderFns } from "./RestrictionPage.vue?vue&type=template&id=964a768c&scoped=true"
import script from "./RestrictionPage.vue?vue&type=script&lang=ts"
export * from "./RestrictionPage.vue?vue&type=script&lang=ts"
import style0 from "./RestrictionPage.vue?vue&type=style&index=0&id=964a768c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964a768c",
  null
  
)

export default component.exports